import * as React from 'react';
import { DatePickerProps } from '@material-ui/pickers';
import { FormikProps } from 'formik';
import moment, { Moment } from 'moment';
import DatePicker from '../DatePicker/DatePicker';

type FormikDatePickerProps = Omit<DatePickerProps, 'onChange' | 'value'> & {
  valueId: string;
  formik: FormikProps<any>;
  emptyLabel?: string;
  minDate?: Moment;
  maxDate?: Moment;
  shouldDisableDate?: (date: Moment) => boolean;
  'data-test'?: string;
};

const FormikDatePicker: React.FC<FormikDatePickerProps> = (
  { formik, valueId, helperText, minDate, maxDate, shouldDisableDate, ...props },
) => {
  const { values, errors, handleChange, touched, handleBlur } = formik;
  const error = !!errors[valueId] && !!touched[valueId];

  // Convert value to Moment if it's not already
  const rawValue = values[valueId];
  let value: Moment | null = null;
  if (rawValue) {
    if (moment.isMoment(rawValue)) {
      value = rawValue;
    } else if (rawValue instanceof Date || typeof rawValue === 'string') {
      value = moment(rawValue);
    }
  }

  const handleChangePatch = (date: Moment | null) => {
    // Store as Moment object in formik
    handleChange({ target: { id: valueId, value: date } });
  };

  return (
    <DatePicker
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      name={valueId}
      data-test={props['data-test'] || valueId}
      value={value}
      error={error}
      onChange={handleChangePatch}
      onBlur={handleBlur}
      helperText={error ? errors[valueId] : helperText}
      minDate={minDate}
      maxDate={maxDate}
      shouldDisableDate={shouldDisableDate}
    />
  );
};

export default FormikDatePicker;
